import { render, staticRenderFns } from "./LayerMetadata.vue?vue&type=template&id=b64d84fa"
import script from "./LayerMetadata.vue?vue&type=script&lang=js"
export * from "./LayerMetadata.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports